import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { equipmentLabelsApi } from "@/lib/api/equipmentLabels";
import { errorMessage } from "@/lib/api";
import { useEquipmentAccess } from "@/components/site-equipment/shared";
import { EquipmentBack } from "@/components/site-equipment/EquipmentNavigation";
import { EquipmentRouteButton } from "@/components/site-equipment/shared";

export function EquipmentQrPage() {
  const { token = "" } = useParams();
  const navigate = useNavigate();
  const access = useEquipmentAccess();
  const [error, setError] = useState("");
  const [attempt, setAttempt] = useState(0);
  useEffect(() => {
    if (!access.read) return;
    const controller = new AbortController();
    void equipmentLabelsApi
      .resolve(token, true, controller.signal)
      .then((piece) => {
        if (!controller.signal.aborted)
          navigate(`/oprema/komadi/${piece.id}`, { replace: true });
      })
      .catch((cause) => {
        if (!controller.signal.aborted)
          setError(
            errorMessage(cause, "QR oznaka nije pronađena ili nije dostupna."),
          );
      });
    return () => controller.abort();
  }, [token, attempt, access.read, navigate]);
  if (!access.read) return <p role="alert">Nemate ovlast za pregled opreme.</p>;
  return (
    <div className="site-equipment equipment-form">
      <EquipmentBack
        crumbs={[
          { label: "Skeniraj", to: "/oprema/skeniraj" },
          { label: "QR oznaka" },
        ]}
      />
      <h1 className="text-xl font-bold">QR oznaka opreme</h1>
      {error ? (
        <>
          <p role="alert">{error}</p>
          <Button
            onClick={() => {
              setError("");
              setAttempt((n) => n + 1);
            }}
          >
            Pokušaj ponovno
          </Button>
          <EquipmentRouteButton to="/oprema">
            Otvori Opremu
          </EquipmentRouteButton>
        </>
      ) : (
        <p role="status">Tražim komad…</p>
      )}
    </div>
  );
}
